import packageInfo from '../../../package.json';

export const environmentCircuits = {
  production: false,
  webVersion: packageInfo.version,
  url: 'https://api.wisen.dev/api',
  timerObservableSeconds: 60,
  helpSupport: 'https://circuits.atlassian.net/servicedesk/customer/portals',
  cloudFront: 'http://d12cs8ei5k77d6.cloudfront.net/',
  canAccessReportVehicle: 'f229c40f-ef97-41c7-9018-c0ecf498d8ac',
  googleMaps: {
    apiKey: 'AIzaSyClHyey7-49Tbm1V0ESDqDtQFR9C5dyC5c',
    mapId: 'a6cc454bc32919fabdbd8402'
  }
};
